import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { User_info_auth } from 'src/app/authentication/models/user_info';
import { AuthenticationService } from 'src/app/authentication/services/authentification.service';
import { HeaderComponent } from '../header.component';

@Component({
    selector: 'app-modal-logout',
    imports: [
        MatDialogModule,
        MatProgressSpinnerModule,
        MatButtonModule
    ],
    templateUrl: './modal-logout.component.html',
    styleUrl: './modal-logout.component.css'
})
export class ModalLogoutComponent {
  currentUser: User_info_auth;
  load : boolean = false

  constructor(
      private router: Router,
      private authenticationService: AuthenticationService
  ) {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }

  logout() {
    this.load = true
    this.authenticationService.logout(this.currentUser.user.id, this.currentUser.auth.token.id);
    this.router.navigateByUrl('/signin');
  }

  readonly dialogRef = inject(MatDialogRef<HeaderComponent>);
}
